var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.savingChanges,
          expression: "savingChanges"
        }
      ],
      staticClass: "box-card",
      attrs: { shadow: "hover" }
    },
    [
      _c(
        "div",
        { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addUser || _vm.addForeignUser,
                  expression: "addUser || addForeignUser"
                }
              ],
              staticStyle: { float: "right", padding: "5px", margin: "10px" },
              attrs: { type: "text" },
              on: { click: _vm.hideForm }
            },
            [_vm._v("Κλείσιμο")]
          ),
          _vm._v(" "),
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addUser && !_vm.modifyUser && !_vm.modifyRole,
                  expression: "addUser && !modifyUser && !modifyRole"
                }
              ],
              attrs: { align: "center" }
            },
            [_vm._v("Εγγραφή Νέου Χρήστη")]
          ),
          _vm._v(" "),
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.addUser && _vm.modifyUser && !_vm.modifyRole,
                  expression: "!addUser && modifyUser && !modifyRole"
                }
              ],
              attrs: { align: "center" }
            },
            [_vm._v("Τροποποίηση Προφίλ Χρήστη")]
          ),
          _vm._v(" "),
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.addUser &&
                    !_vm.modifyUser &&
                    !_vm.modifyRole &&
                    _vm.addForeignUser,
                  expression:
                    "!addUser && !modifyUser && !modifyRole && addForeignUser"
                }
              ],
              attrs: { align: "center" }
            },
            [_vm._v("Εγγραφή Αλλοδαπού Χρήστη")]
          ),
          _vm._v(" "),
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.addUser && !_vm.modifyUser && _vm.modifyRole,
                  expression: "!addUser && !modifyUser && modifyRole"
                }
              ],
              attrs: { align: "center" }
            },
            [
              _vm._v(
                "Προσθήκη/Αφαίρεση Χρηστών από τον Ρόλο " + _vm._s(_vm.roleName)
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "userCredentials",
              staticClass: "ruleForm",
              attrs: {
                inline: true,
                "inline-message": true,
                model: _vm.userCredentials,
                rules: _vm.validationRules,
                "label-width": "124px",
                size: "small"
              }
            },
            [
              _vm.modifyFromUser
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Αλλαγή Κωδικού" } },
                    [
                      _c("el-switch", {
                        staticClass: "register",
                        attrs: {
                          "active-text": "Αλλαγή",
                          "inactive-text": "Διατήρηση",
                          "active-value": true,
                          "inactive-value": false
                        },
                        model: {
                          value: _vm.changePassword,
                          callback: function($$v) {
                            _vm.changePassword = $$v
                          },
                          expression: "changePassword"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.modifyFromUser && _vm.changePassword
                ? _c(
                    "el-card",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [_c("h3", [_vm._v("Αλλαγή Κωδικού")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Παλιός κωδικός",
                            prop: "oldPassword"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "register",
                            attrs: { type: "password", "auto-complete": "off" },
                            on: { change: _vm.modifyUserPassword },
                            model: {
                              value: _vm.userCredentials.oldPassword,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.userCredentials,
                                  "oldPassword",
                                  $$v
                                )
                              },
                              expression: "userCredentials.oldPassword"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Νέος κωδικός", prop: "password" } },
                        [
                          _c("el-input", {
                            staticClass: "register",
                            attrs: { type: "password", "auto-complete": "off" },
                            on: { change: _vm.modifyUserPassword },
                            model: {
                              value: _vm.userCredentials.password,
                              callback: function($$v) {
                                _vm.$set(_vm.userCredentials, "password", $$v)
                              },
                              expression: "userCredentials.password"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Επανάληψη νέου κωδικού",
                            prop: "passwordConfirmation"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "register",
                            attrs: { type: "password", "auto-complete": "off" },
                            on: { change: _vm.modifyUserPassword },
                            model: {
                              value: _vm.userCredentials.passwordConfirmation,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.userCredentials,
                                  "passwordConfirmation",
                                  $$v
                                )
                              },
                              expression: "userCredentials.passwordConfirmation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: { label: "Email", prop: "email", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserEmail },
                    model: {
                      value: _vm.userCredentials.email,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "email", $$v)
                      },
                      expression: "userCredentials.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: {
                    label: "Όνομα Χρήστη",
                    prop: "username",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "username",
                      "auto-complete": "off",
                      size: "large"
                    },
                    model: {
                      value: _vm.userCredentials.username,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "username", $$v)
                      },
                      expression: "userCredentials.username"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: { label: "Επώνυμο", prop: "surname", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserName,
                      input: function($event) {
                        _vm.userCredentials.surname = _vm.userCredentials.surname.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.surname,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "surname", $$v)
                      },
                      expression: "userCredentials.surname"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: { label: "Όνομα", prop: "name", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserName,
                      input: function($event) {
                        _vm.userCredentials.name = _vm.userCredentials.name.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.name,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "name", $$v)
                      },
                      expression: "userCredentials.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: {
                    label: "Πατρώνυμο",
                    prop: "fatherName",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserEmail,
                      input: function($event) {
                        _vm.userCredentials.fatherName = _vm.userCredentials.fatherName.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.fatherName,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "fatherName", $$v)
                      },
                      expression: "userCredentials.fatherName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: {
                    label: "Μητρώνυμο",
                    prop: "motherName",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserName,
                      input: function($event) {
                        _vm.userCredentials.motherName = _vm.userCredentials.motherName.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.motherName,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "motherName", $$v)
                      },
                      expression: "userCredentials.motherName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: {
                    label: "Σταθερό Τηλ.",
                    prop: "landline",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserName },
                    model: {
                      value: _vm.userCredentials.landline,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "landline", $$v)
                      },
                      expression: "userCredentials.landline"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: { label: "Κινητό", prop: "mobile", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserName },
                    model: {
                      value: _vm.userCredentials.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "mobile", $$v)
                      },
                      expression: "userCredentials.mobile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modifyRole,
                    expression: "!modifyRole"
                  }
                ]
              }),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: {
                    label: "Περιοχή",
                    prop: "addressArea",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserEmail,
                      input: function($event) {
                        _vm.userCredentials.addressArea = _vm.userCredentials.addressArea.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.addressArea,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "addressArea", $$v)
                      },
                      expression: "userCredentials.addressArea"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: { label: "Πόλη", prop: "addressCity", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserName,
                      input: function($event) {
                        _vm.userCredentials.addressCity = _vm.userCredentials.addressCity.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.addressCity,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "addressCity", $$v)
                      },
                      expression: "userCredentials.addressCity"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: {
                    label: "Χώρα",
                    prop: "addressCountry",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserName,
                      input: function($event) {
                        _vm.userCredentials.addressCountry = _vm.userCredentials.addressCountry.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.addressCountry,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "addressCountry", $$v)
                      },
                      expression: "userCredentials.addressCountry"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: {
                    label: "Διεύθυνση",
                    prop: "addressStreet",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: {
                      change: _vm.modifyUserEmail,
                      input: function($event) {
                        _vm.userCredentials.addressStreet = _vm.userCredentials.addressStreet.toUpperCase()
                      }
                    },
                    model: {
                      value: _vm.userCredentials.addressStreet,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "addressStreet", $$v)
                      },
                      expression: "userCredentials.addressStreet"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: {
                    label: "Τ.Κ.",
                    prop: "addressZipCode",
                    size: "large"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserName },
                    model: {
                      value: _vm.userCredentials.addressZipCode,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "addressZipCode", $$v)
                      },
                      expression: "userCredentials.addressZipCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modifyUser && !_vm.modifyRole,
                    expression: "modifyUser && !modifyRole"
                  }
                ]
              }),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: { label: "Ταυτότητα", prop: "adtNo", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserEmail },
                    model: {
                      value: _vm.userCredentials.adtNo,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "adtNo", $$v)
                      },
                      expression: "userCredentials.adtNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: { label: "ΑΦΜ", prop: "afm", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large",
                      disabled: _vm.modifyFromUser
                    },
                    on: { change: _vm.modifyUserName },
                    model: {
                      value: _vm.userCredentials.afm,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "afm", $$v)
                      },
                      expression: "userCredentials.afm"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole,
                      expression: "!modifyRole"
                    }
                  ],
                  attrs: {
                    label: "Η/νια Γέννησης",
                    prop: "dateOfBirth",
                    size: "large"
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "Επιλέξτε Ημερομην.",
                      format: "dd-MM-yyyy",
                      "value-format": "dd-MM-yyyy"
                    },
                    model: {
                      value: _vm.userCredentials.dateOfBirth,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "dateOfBirth", $$v)
                      },
                      expression: "userCredentials.dateOfBirth"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: { label: "ΔΟΥ", prop: "doy", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "register",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserName },
                    model: {
                      value: _vm.userCredentials.doy,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "doy", $$v)
                      },
                      expression: "userCredentials.doy"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.modifyRole && _vm.addForeignUser
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Αριθμός Διαβατηρίου",
                        prop: "foreignerId.number",
                        size: "large"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "register",
                        attrs: {
                          type: "name",
                          "auto-complete": "off",
                          size: "large"
                        },
                        on: { change: _vm.modifyUserName },
                        model: {
                          value: _vm.userCredentials.foreignerId.number,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userCredentials.foreignerId,
                              "number",
                              $$v
                            )
                          },
                          expression: "userCredentials.foreignerId.number"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.modifyRole && _vm.addForeignUser
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Χώρα έκδοσης",
                        prop: "foreignerId.country",
                        size: "large"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "register",
                        attrs: {
                          type: "name",
                          "auto-complete": "off",
                          size: "large"
                        },
                        on: {
                          change: _vm.modifyUserName,
                          input: function($event) {
                            _vm.userCredentials.foreignerId.country = _vm.userCredentials.foreignerId.country.toUpperCase()
                          }
                        },
                        model: {
                          value: _vm.userCredentials.foreignerId.country,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userCredentials.foreignerId,
                              "country",
                              $$v
                            )
                          },
                          expression: "userCredentials.foreignerId.country"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modifyRole && !_vm.addForeignUser,
                      expression: "!modifyRole && !addForeignUser"
                    }
                  ],
                  attrs: { label: "ΙΒΑΝ", prop: "iban", size: "large" }
                },
                [
                  _c("el-input", {
                    staticClass: "iban",
                    attrs: {
                      type: "name",
                      "auto-complete": "off",
                      size: "large"
                    },
                    on: { change: _vm.modifyUserEmail },
                    model: {
                      value: _vm.userCredentials.iban,
                      callback: function($$v) {
                        _vm.$set(_vm.userCredentials, "iban", $$v)
                      },
                      expression: "userCredentials.iban"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeRole === "Admin"
                ? [
                    _c("hr"),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.modifyRole && !_vm.addForeignUser,
                            expression: "!modifyRole && !addForeignUser"
                          }
                        ],
                        attrs: {
                          label: "ID χρήστη ΣΗΔΕ",
                          prop: "eProtocol_userId",
                          size: "large"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "register",
                          attrs: {
                            type: "number",
                            min: "1",
                            step: "1",
                            "auto-complete": "off",
                            size: "large"
                          },
                          on: { change: _vm.modifyUserEmail },
                          model: {
                            value: _vm.userCredentials.eProtocol_userId,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.userCredentials,
                                "eProtocol_userId",
                                $$v
                              )
                            },
                            expression: "userCredentials.eProtocol_userId"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSpecialties,
                      expression: "showSpecialties"
                    }
                  ],
                  attrs: {
                    label: "Ειδικότητα",
                    prop: "specialty",
                    size: "large"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { "padding-right": "10px" },
                      attrs: {
                        placeholder: "Επιλέξτε",
                        disabled: _vm.activeRole !== "Admin"
                      },
                      on: { change: _vm.changeSelectedSpecialty },
                      model: {
                        value: _vm.selectedSpecialty,
                        callback: function($$v) {
                          _vm.selectedSpecialty = $$v
                        },
                        expression: "selectedSpecialty"
                      }
                    },
                    _vm._l(_vm.academicAreas, function(specialty) {
                      return _c("el-option", {
                        key: specialty.id,
                        attrs: { label: specialty.name, value: specialty.id }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _vm.showSpecialties &&
                  !_vm.selectedSpecialty &&
                  _vm.activeRole === "Admin"
                    ? _c("el-alert", {
                        staticStyle: { display: "inline" },
                        attrs: {
                          closable: true,
                          title:
                            "Πρέπει να επιλέξετε την ειδικότητα του συμβούλου",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modifyRole,
                    expression: "!modifyRole"
                  }
                ]
              }),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.modifyRole &&
                        !_vm.modifyFromUser &&
                        !_vm.addForeignUser,
                      expression:
                        "modifyRole && !modifyFromUser && !addForeignUser"
                    }
                  ],
                  attrs: { label: "Χρήστες/Ρόλο" }
                },
                [
                  _c("el-transfer", {
                    staticStyle: {
                      "text-align": "left",
                      display: "inline-block"
                    },
                    attrs: {
                      filterable: "",
                      titles: ["Απομείναντες Χρήστες", "Χρήστες Ρόλου"],
                      "button-texts": ["Αφαίρεση", "Προσθήκη"],
                      data: _vm.users
                    },
                    on: { change: _vm.addUserToRole },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var option = ref.option
                          return _c("span", {}, [_vm._v(_vm._s(option.label))])
                        }
                      }
                    ]),
                    model: {
                      value: _vm.usersPerRole,
                      callback: function($$v) {
                        _vm.usersPerRole = $$v
                      },
                      expression: "usersPerRole"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.modifyRole &&
                        !_vm.modifyFromUser &&
                        !_vm.addForeignUser,
                      expression:
                        "!modifyRole && !modifyFromUser && !addForeignUser"
                    }
                  ],
                  attrs: { label: "Επιλογή Ρόλων" }
                },
                [
                  _c("el-transfer", {
                    staticStyle: {
                      "text-align": "left",
                      display: "inline-block"
                    },
                    attrs: {
                      filterable: "",
                      titles: ["Απομείναντες Ρόλοι", "Ρόλοι Χρήστη"],
                      "button-texts": ["Αφαίρεση", "Προσθήκη"],
                      data: _vm.rolesHere
                    },
                    on: { change: _vm.addRoleToUser },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var option = ref.option
                          return _c("span", {}, [
                            _vm._v(
                              _vm._s(option.key) + " - " + _vm._s(option.label)
                            )
                          ])
                        }
                      }
                    ]),
                    model: {
                      value: _vm.userRoles,
                      callback: function($$v) {
                        _vm.userRoles = $$v
                      },
                      expression: "userRoles"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "saveButtons",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modifyRole,
                          expression: "modifyRole"
                        }
                      ],
                      attrs: { type: "primary", disabled: !_vm.modifiedRole },
                      on: { click: _vm.roleSave }
                    },
                    [_vm._v("Αποθήκευση Ρόλου")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.modifyRole &&
                        _vm.roleId === 3 &&
                        !_vm.modifyFromUser &&
                        !_vm.addForeignUser,
                      expression:
                        "modifyRole && roleId === 3 && !modifyFromUser && !addForeignUser"
                    }
                  ]
                },
                [
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Επιλογή Επιτροπής" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Select" },
                          on: { change: _vm.newSelectedBoard },
                          model: {
                            value: _vm.selectedBoard,
                            callback: function($$v) {
                              _vm.selectedBoard = $$v
                            },
                            expression: "selectedBoard"
                          }
                        },
                        _vm._l(_vm.boards, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.name }
                          })
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedBoard !== ""
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Επιλογή Μελών Επιτροπής" } },
                            [
                              _c("el-transfer", {
                                staticStyle: {
                                  "text-align": "left",
                                  display: "inline-block"
                                },
                                attrs: {
                                  filterable: "",
                                  titles: [
                                    "Χρήστες Συμβουλίων",
                                    "Χρήστες Συμβουλίου"
                                  ],
                                  "button-texts": ["Αφαίρεση", "Προσθήκη"],
                                  data: _vm.executiveBoardMembers
                                },
                                on: { change: _vm.addUserToRole },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var option = ref.option
                                      return _c("span", {}, [
                                        _vm._v(_vm._s(option.label))
                                      ])
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.specificBoardMembers,
                                  callback: function($$v) {
                                    _vm.specificBoardMembers = $$v
                                  },
                                  expression: "specificBoardMembers"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "saveButtons",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top-start",
                        title: "Προϋποθέσεις Αποθήκευσης",
                        width: "200",
                        trigger: "hover",
                        content: "Συμπληρώστε όλα τα υποχρεωτικά πεδία"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.modifyRole && !_vm.addForeignUser,
                              expression: "!modifyRole && !addForeignUser"
                            }
                          ],
                          attrs: { slot: "reference", type: "primary" },
                          on: { click: _vm.userSave },
                          slot: "reference"
                        },
                        [_vm._v("Αποθήκευση Χρήστη")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top-start",
                        title: "Προϋποθέσεις Αποθήκευσης",
                        width: "200",
                        trigger: "hover",
                        content: "Συμπληρώστε όλα τα υποχρεωτικά πεδία"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.modifyRole && _vm.addForeignUser,
                              expression: "!modifyRole && addForeignUser"
                            }
                          ],
                          attrs: { slot: "reference", type: "primary" },
                          on: { click: _vm.foreignUserSave },
                          slot: "reference"
                        },
                        [_vm._v("Αποθήκευση Αλλοδαπού Χρήστη")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.modifyRole &&
                            !_vm.addUser &&
                            !_vm.modifyFromUser &&
                            !_vm.addForeignUser,
                          expression:
                            "!modifyRole && !addUser && !modifyFromUser && !addForeignUser"
                        }
                      ],
                      attrs: { type: "danger", icon: "el-icon-delete" },
                      on: { click: _vm.userDelete }
                    },
                    [_vm._v("Διαγραφή Χρήστη")]
                  ),
                  _vm._v(" "),
                  _vm.modifyRole &&
                  _vm.roleId === 3 &&
                  !_vm.modifyFromUser &&
                  !_vm.addForeignUser
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.canSaveBoard
                          },
                          on: { click: _vm.boardSave }
                        },
                        [_vm._v("Αποθήκευση Συμβουλίου")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modifyFromUser && !_vm.addForeignUser
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "info" },
                          on: { click: _vm.backToApplications }
                        },
                        [_vm._v("Επιστροφή")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.modifyFromUser &&
                  _vm.modifyUser &&
                  !_vm.modifyRole &&
                  !_vm.addUser &&
                  !_vm.addForeignUser
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.newPassword }
                        },
                        [_vm._v("Νέος Κωδικός")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.confirmDialog.title,
            visible: _vm.confirmDialog.visible,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.$set(_vm.confirmDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("p", [
              _c("strong", [_vm._v("Πριν:")]),
              _vm._v(" " + _vm._s(_vm.confirmDialog.before || "(κανένας)"))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Μετά:")]),
              _vm._v(" " + _vm._s(_vm.confirmDialog.after || "(κανένας)"))
            ]),
            _vm._v(" "),
            _vm.confirmDialog.added.length
              ? _c("div", [
                  _c("p", { staticStyle: { color: "#67c23a" } }, [
                    _c("strong", [_vm._v("Προστίθενται:")]),
                    _vm._v(" " + _vm._s(_vm.confirmDialog.added.join(", ")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.confirmDialog.removed.length
              ? _c("div", [
                  _c("p", { staticStyle: { color: "#f56c6c" } }, [
                    _c("strong", [_vm._v("Αφαιρούνται:")]),
                    _vm._v(" " + _vm._s(_vm.confirmDialog.removed.join(", ")))
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.confirmDialog.visible = false
                    }
                  }
                },
                [_vm._v("Ακύρωση")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmDialog.onConfirm }
                },
                [_vm._v("Αποθήκευση")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bee30b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bee30b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RegisterForm.vue
// module id = null
// module chunks = 